import { BaseResource } from '../core/base-resource';

export class LoyaltyMembership extends BaseResource {
  readonly loyaltyPlan: string;
  readonly points: number;
  readonly availablePoints: number;
  readonly lifetimePoints: number;
  readonly dateJoined: string;
}
